/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useLayoutEffect } from 'react';
import { Helmet } from 'react-helmet';
import Member from './Member/Member';

import { useSetRecoilState } from 'recoil';
import { isHeaderBlackState } from '../../store/atoms';

import styled from 'styled-components';

export default function Team() {
  const setIsHeaderBlack = useSetRecoilState(isHeaderBlackState);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useLayoutEffect(() => {
    setIsHeaderBlack(false);
  }, []);

  return (
    <>
      <Helmet>
        <meta property="og:description" content="인텔리퀀트의 팀원" />
        <meta name="description" content="인텔리퀀트의 팀원" />
      </Helmet>
      <StyledTeam>
        <StyledTeamContentsContainer>
          <StyledTag>OUR TEAM</StyledTag>
          <StyledTitle>
            금융과 IT의 진정한 접목이라는 그 누구도 풀지 못한 <br />
            난제를 풀기 위해 최고의 전문가들이 모였습니다.
          </StyledTitle>
          <StyledTeamMembersContainer>
            {TEAM_MEMBER.map(({ name, image, role, info, careers }, index) => {
              return (
                <Member
                  key={index + 1}
                  name={name}
                  image={image}
                  role={role}
                  info={info}
                  careers={careers}
                />
              );
            })}
          </StyledTeamMembersContainer>
        </StyledTeamContentsContainer>
      </StyledTeam>
    </>
  );
}

const StyledTeam = styled.section`
  margin-top: 184px;
  overflow-x: hidden;

  ${({ theme }) => theme.mobile`
    margin-top: 134px;
  `}
`;

const StyledTeamContentsContainer = styled.article`
  max-width: 1340px;
  margin: 0 auto 144px;
  padding: 0 30px;

  ${({ theme }) => theme.mobile`
  padding: 0 32px;
  margin: 0 auto 76px;
  `}
`;

const StyledTag = styled.h1`
  margin-bottom: 18px;
  color: ${({ theme }) => theme.colors.green};
  font-size: ${({ theme }) => theme.pixelToRem(14)};

  ${({ theme }) => theme.mobile`
    font-size: ${({ theme }) => theme.pixelToRem(14)}

  `}
`;

const StyledTitle = styled.h2`
  margin-bottom: 100px;
  font-size: ${({ theme }) => theme.pixelToRem(30)};
  font-weight: 700;
`;

const StyledTeamMembersContainer = styled.ul`
  ${({ theme }) => theme.flex('row', 'center', 'stretch')};
  display: flex;
  flex-wrap: wrap;
  column-gap: 56px;

  ${({ theme }) => theme.mobile`
  ${({ theme }) => theme.flex('row', 'space-between', 'stretch')};
  gap: 0;
  row-gap: 28px;
  `}

  li:nth-child(1),
  li:nth-child(2),
  li:nth-child(3) {
    div:hover {
      img:first-child {
        opacity: 0.07;
        transition: all 0.3s;
      }

      ul {
        transition: all 0.3s;
        opacity: 1;
      }
    }
  }
`;

const TEAM_MEMBER = [
  {
    name: 'Joseph',
    image: 'images/Team/member/Joseph/group@3x.png',
    role: 'CEO',
    info: 'Joseph은 IT와 투자 분야를 두루 거친 경험과 전문성을 바탕으로 개인투자자를 위한 투자서비스를 혁신하고자 인텔리퀀트를 창업하였으며, 사업전략과 투자운용을 총괄하고 있습니다.',
    careers: [
      'KAIST 전기 및 전자공학과 학/석/박사',
      '한국 IBM 유비쿼터스 컴퓨팅 Lab 부장',
      '에이서투자자문 퀀트운용 총괄',
    ],
  },
  {
    name: 'Joeffrey',
    image: 'images/Team/member/Joeffrey/group-2@3x.png',
    role: 'CTO',
    info: 'Joeffrey는 인텔리퀀트의 기술과 금융의 접목 과정을 총괄하고 있습니다. 개인적으로 촘촘한 모니터링과 시스템의 장애예방에 많은 관심을 가지고 있습니다.',
    careers: [
      'KAIST 전산학과 학사',
      '네이버 / 카카오 / PUBG Senior Software Engineer',
      '23년 이상 SW개발 및 엔지니어링 경력',
    ],
  },
  {
    name: 'Alex',
    image: 'images/Team/member/Alex/group-5@3x.png',
    role: 'CFO',
    info: 'Alex는 인텔리퀀트의 운영과 재무에 관련된 사항을 총괄하며, 구성원들이 업무를 잘 수행할 수 있도록 돕는 역할을 담당하고 있습니다.',
    careers: [
      'KAIST 산업공학 학사',
      '한양대학교 MBA',
      '한글과컴퓨터 신제품마케팅 팀장',
      '바른소프트기술 경영기획실장',
    ],
  },
  {
    name: 'Sebastian',
    image: 'images/Team/member/Sebastian/group-6@3x.png',
    role: 'R&D Director',
    info: 'Sebastian은 새로운 기술에 대한 관심이 많은 개발자로, 다양한 IT 분야에서 일했던 경험을 살려 인텔리퀀트의 기술을 고도화시키고 있습니다.',
    careers: [],
  },
  {
    name: 'Raymond',
    image: 'images/Team/member/Raymond/group-7@3x.png',
    role: 'Quant Manager',
    info: 'Raymond는 다년에 걸친 자산운용과 트레이딩 경험을 바탕으로 인텔리퀀트의 금융,디지털 자산 투자전략을 고도화 시키고 있습니다.',
    careers: [],
  },
  {
    name: 'Steve',
    image: 'images/Team/member/Steve/group-8@3x.png',
    role: 'Quant Developer',
    info: 'Steve는 금융과 데이터와 개미를 좋아하는 퀀트개발자입니다. 복잡한 계산을 대신 해주는 코드를 통해 쉬운 금융을 만들고자 합니다.',
    careers: [],
  },
  {
    name: 'Jamie',
    image: 'images/Team/member/Jamie/group-10@3x.png',
    role: 'Front-end Developer',
    info: 'Jamie는 재밌게, 프로페셔널하게. 두 가지의 균형 속에서 최상의 경험을 함께 상상하고 스크린에 풀어내어 여러분을 맞이하는 개발자입니다.',
    careers: [],
  },
  {
    name: 'Jacob',
    image: 'images/Team/member/Jacob/group-11@3x.png',
    role: 'Back-end Developer',
    info: 'Jacob은 인텔리퀀트의 엔진을 개발 하고 있는 개발자로 사용자들이 믿고 사용할 수 있는 알고리즘 투자 플랫폼 개발을 목표로 하고 있습니다.',
    careers: [],
  },
  {
    name: 'Devin',
    image: 'images/Team/member/Devin/group-15@3x.png',
    role: 'Marketing Manager',
    info: 'Devin은 그로스 마케터로서 데이터에 기반한 마케팅 전략을 수립하고 사용자 친화적인 커뮤니티 환경 조성을 담당하고 있습니다.',
    careers: [],
  },
  // {
  //   name: 'Dawn',
  //   image: 'images/Team/member/Dawn/dawn.jpg',
  //   role: 'Product Designer',
  //   info: 'Dawn은 디자이너로서 사용자가 필요한 것을 기획, 설계하고 화면으로 구체화해 표현하여 최상의 사용자 경험을 전달하고자 합니다.',
  //   careers: [],
  // },
  // {
  //   name: 'JD',
  //   image: 'images/Team/member/JD/jd.jpg',
  //   role: 'Front-end Developer',
  //   info: 'JD는 프론트엔드 개발자로서 서비스 품질을 개선하여 고객이 인텔리퀀트의 제품을 접근하기 쉽고 편리하게 이용하고자 합니다.',
  //   careers: [],
  // },
];
